import { Action } from '@ngrx/store';

export class Booking {
  private appConfig: any;
  private requestUrl?: any;
  private settings?: any;
  public logo?: string;
}

export const BOOKING_REQUEST = 'BOOKING_REQUEST';
export const BOOKING_REQUEST_PROCESSING = 'BOOKING_REQUEST_PROCESSING';
export const BOOKING_REQUEST_SUCCESS = 'BOOKING_REQUEST_SUCCESS';
export const BOOKING_REQUEST_FAILURE = 'BOOKING_REQUEST_FAILURE';

export class BookingAction implements Action {
  public type;

  constructor(
    public payload: Booking
  ) {}
}



// WEBPACK FOOTER //
// /Users/dtrubetskoi/Desktop/projects/online-booking-widget/src/app/actions/booking.action.ts